export const isFinOn = process.env.REACT_APP_FIN === "fin";
export const isQi = process.env.REACT_APP_FIN === "qi";
